<div
  *ngIf="data"
  class="currency-view"
>
  <div class="currency-view__code">{{ data.code }}</div>
  <div
    class="currency-view__value"
    qimaAutoTooltip
    [qimaAutoTooltipStyle]="qimaTooltip.style.DARK"
    [qimaAutoTooltipPosition]="qimaTooltip.position.TOP_RIGHT"
    [qimaAutoTooltipText]="formatAmount(data.value, data.code)"
    [qimaAutoTooltipStrategy]="qimaTooltip.strategy.ON_HOVER"
    [qimaAutoTooltipHasArrow]="true"
  >
    {{ formatAmount(data.value, data.code) }}
  </div>
</div>
